<template>
    <div v-if="haslatLng">
        <div class="commute_section" v-for="(item, index) in fullCommuteArray" v-bind:key="index">
            <span class="address_section">
                <a :href="item.mapUrl">
                    <i class="icon-location-arrow"></i>
                </a>
                <div class="distance_text">
                    <b class="distance">{{item.distance}} {{getMilesTxt(item.distance)}}</b> from this home to<br />
                    <span>{{item.name}}</span>
                </div>
                <i class="icon-times" @click="removeCommute(index)"  role="button"></i>
            </span>
            <div class="commute_details">
                <div class="left"><i class="icon-car"></i> <span>{{item.carCommute}}</span></div>
                <div><i class="icon-bicycle"></i> <span>{{item.bicycleCommute}}</span></div>
                <div class="right"><i class="icon-walking"></i> <span>{{item.walkCommute}}</span></div>
            </div>
            <hr />
        </div>
        <div class="commute-search-panel">
            <mvtInputGeo ref="addressInput" class="normal" btnclass="" v-model="geoInfo" :placeholder="molang('dpp.propertyCommute.commuteAddress')" />
        </div>
        <div class="paragraph f7"  v-if="showNotSupportedByMLS()">
            {{molang('dpp.movotoPowered')}}
        </div>
    </div>
</template>
<script src="./property-commute.js"></script>

<style lang="scss">
@use "./property-commute.scss" as *;
</style>

